export default __webpack_public_path__ + "static/media/10-1.a2792633.jpg";